import React from "react";
import { ThemeProvider } from "styled-components";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import theme from "../utils/MUI/generic-override.js";
import "../styles/signup/signup.scss";
import { SignupFormStateProvider, signupFormStore } from "../store/signup-form-reducer.jsx";
import { CurrentUserProvider } from "../store/current-user-context.jsx";
import SignupView from "./signup-view.jsx";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Toaster } from 'sonner';
import { isProd } from "../utils/env-util.js";

const STRIPE_TEST_KEY = "pk_test_To6BQb6bJUc2RMrrsgYC22Ki";
const STRIPE_PROD_KEY = "pk_live_sUosV5PD5RgjRmEtCFYtKPtf";
const stripeKey = isProd() ? STRIPE_PROD_KEY : STRIPE_TEST_KEY;
const RECAPTCHA_TEST_KEY = "6LdWP90rAAAAAI7z94YKUH9yITN7828Js1ZFpnPo";
const RECAPTCHA_PROD_KEY = "6LdW6KwrAAAAAJv144GSZEOtg03e8W9g0TF_OEbE";
const recaptchaKey = isProd() ? RECAPTCHA_PROD_KEY : RECAPTCHA_TEST_KEY;
const stripePromise = loadStripe(stripeKey);

const SignupApp = () => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
            <CurrentUserProvider>
                <SignupFormStateProvider>
                    <ThemeProvider theme={theme}>
                        <Elements stripe={stripePromise}>
                            <SignupView />
                            <Toaster richColors />
                        </Elements>
                    </ThemeProvider>
                </SignupFormStateProvider>
            </CurrentUserProvider>
        </GoogleReCaptchaProvider>
    );
};

export default SignupApp;
